import PropTypes from 'prop-types'

import { Dropdown } from 'primereact/dropdown'
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

import mnStyle from '@aytm/app/stats/page/question-views/mn/Controls.module.scss'

const ViewModeDropdown = ({ options, value, width, onChange }) => {
  const helpText = options?.find(o => o.value === value)?.help || ''

  const handleChange = event => {
    onChange({ viewMode: event.value })
  }

  return (
    <>
      <div className={`p-fluid ${mnStyle.dropdown}`} style={width ? { width } : undefined}>
        <Dropdown
          className="p-dropdown-rounded"
          value={value}
          options={options}
          optionValue="value"
          optionLabel="text"
          optionDisabled="disabled"
          fixedDropdownDir="bottom"
          onChange={handleChange}
        />
      </div>
      {helpText ? (
        <Popup
          width="220px"
          trigger="click"
          direction="bottomleft"
          popupOffset={9}
          hideOtherPopupsOnShow
          content={() => <p dangerouslySetInnerHTML={{ __html: helpText }} />}
        >
          <i className="icon-aytmfd-help" />
        </Popup>
      ) : null}
    </>
  )
}

ViewModeDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
      listText: PropTypes.string,
      help: PropTypes.string
    })
  ),
  value: PropTypes.string,
  width: PropTypes.number,
  onChange: PropTypes.func
}

ViewModeDropdown.displayName = 'ViewModeDropdown'

export default ViewModeDropdown
